var $ = require('jquery');

let isSticky = false, animatedIn = false;

$(window).on('load', function() {
    if( $('.single').length ) {
        var headerHeight = 0;


        let alertHeight = getComputedStyle(document.querySelector(':root')).getPropertyValue('--alert-height');
        headerHeight = parseFloat(144) + $('.post__navigation').height() + $('.post__header').outerHeight(true);
    
        if ( $('.post__featured-visual').length ) {
            headerHeight += $('.post__featured-visual').outerHeight(true)  / 2;
        }

        if ( $('.site-alert').length ) {
            headerHeight += $('.site-alert').height();
        }
    
        $('.post__accent').css('height', headerHeight);
    }
})

$(window).on('scroll', function() {
    if ( $('.single').length && $(window).width() > 991 ) {
        let topPos = $('.post__share').offset().top;
        let relatedPostPos = $('.post__related-posts').offset().top;
        // || $(window).scrollTop() + ($(window).height() * .6667) >= relatedPostPos
         if ( $(window).scrollTop() < (topPos + 100)  ) {
            if ( isSticky == true ) {
                $('.post__share-options').removeClass('sticky');
                $('.post__share-options').appendTo('.post__share');
                $('.post__share-options').removeClass('animate-in');
                isSticky = false;
                animatedIn = false;
            }   
        } else if ( $(window).scrollTop() >= topPos ) {
            if ( isSticky == false ) {
                $('.post__share-options').appendTo('body');
                $('.post__share-options').addClass('sticky');
                isSticky = true;
    
                if ( animatedIn == false ) {
                    setTimeout(function() {
                        $('.post__share-options').addClass('animate-in');
                    }, 200)
                    animatedIn = true;
                }
            }
        }
    }

    if ( $('.single').length && $(window).width() <= 991 && $('.post__share-options').hasClass('sticky') ) {
        $('.post__share-options').removeClass('sticky');
        $('.post__share-options').appendTo('.post__share');
        $('.post__share-options').removeClass('animate-in');
    }
})